export const NEST = { id: 'home-nest', name: 'Home nest', x: -104, z: 57 };
export const PROVISIONS = [
  { id: 'home-crust', name: 'Croissant provision', x: -86, z: 37 },
  { id: 'home-biscuit', name: 'Biscuit provision', x: -52, z: 41 },
  { id: 'home-flake', name: 'Picnic provision', x: -18, z: 40 },
];
export interface HomeProgress { delivered: string[]; carrying: string | null; dropped: Record<string, { x: number; z: number }> }
export function readHome(value: unknown, inBounds: (x: number, z: number) => boolean = () => true): HomeProgress {
  const p = (value && typeof value === 'object' ? value : {}) as Partial<HomeProgress>;
  const ids = PROVISIONS.map(p => p.id);
  const delivered = [...new Set(Array.isArray(p.delivered) ? p.delivered.filter(id => ids.includes(id)) : [])];
  const carrying = typeof p.carrying === 'string' && ids.includes(p.carrying) && !delivered.includes(p.carrying) ? p.carrying : null;
  const dropped: HomeProgress['dropped'] = {};
  for (const id of ids) {
    const point = p.dropped?.[id];
    if (!delivered.includes(id) && carrying !== id && point && typeof point.x === 'number' && typeof point.z === 'number' && Number.isFinite(point.x) && Number.isFinite(point.z) && inBounds(point.x, point.z)) dropped[id] = { x: point.x, z: point.z };
  }
  return { delivered, carrying, dropped };
}
